import handler from 'api/handler'

const prefix = '/public/settings'

const methods = {
  membershipFees: args => handler({ method: 'get', url: prefix + '/membershipFees', args })
}

export default methods
